// extracted by mini-css-extract-plugin
module.exports = {"label":"input_label__CXZ6C","input":"input_input__5fnmL","active":"input_active__zy_qf"};